import './styles/Forgot.scss';

import { useMutation } from '@apollo/client';
import { Grid, Button, TextField } from '@mui/material';

import { Formik, Field } from 'formik';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';

import FORGOT_PASSWORD_MUTATION from 'gql/mutations/forgotPassword.gql';

import { actions as AlertActions } from 'app/containers/Dashboard/Alert/slice';
import { translations } from 'locales/i18n';

export default function Forgot() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [forgotPassword] = useMutation(FORGOT_PASSWORD_MUTATION);

  const validationSchema = {
    email: yup
      .string()
      .email(t(translations.validation.email()))
      .required(t(translations.validation.required()))
  };

  const handleForgotPassword = async ({ email }) => {
    await forgotPassword({
      variables: { email }
    });

    dispatch(AlertActions.success(t(translations.pages.login.alerts.forgotPasswordSuccessful())));
    navigate('/login');
  };

  return (
    <>
      <Helmet>
        <title>{t(translations.pages.login.confirmTitle())}</title>
      </Helmet>
      <Formik
        onSubmit={values => handleForgotPassword(values)}
        initialValues={{
          email: ''
        }}
        validationSchema={yup.object().shape(validationSchema)}
        isInitialValid={false}
      >
        {({ handleSubmit, touched, errors, values, isValid }) => (
          <form onSubmit={handleSubmit}>
            <Grid container className="forgot-form">
              <Grid container>
                <Grid container className="forgot-form__title">
                  {t(translations.pages.login.forgotTitle())}
                </Grid>
                <Grid container className="forgot-form__description">
                  {t(translations.pages.login.forgotDescription())}
                </Grid>
              </Grid>
              <Grid container>
                <Grid container>
                  <Grid item xs={11} md>
                    <Field
                      className="forgot-form__field"
                      label={t(translations.common.email())}
                      name="email"
                      as={TextField}
                      error={touched.email && errors.email}
                      variant="outlined"
                      size="small"
                      fullWidth
                      type="email"
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid container justifyContent="flex-end">
                <Button color="primary" variant="contained" disabled={!isValid} type="submit">
                  {t(translations.common.confirm())}
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </>
  );
}
